import { createMutation } from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

const RequestSchema = z.object({
  document_id: z.number()
});

const ResponseSchema = z.object({
  id: z.number(),
  document_id: z.number(),
  url: z.string(),
  thumbnail_url: z.string().nullable(),
  creator: z.number()
});

type Request = z.infer<typeof RequestSchema>;
type Response = z.infer<typeof ResponseSchema>;

export const useCreateUnassignedFile = createMutation<Response, Request, Error>(
  {
    mutationFn: async (variables) => {
      return api<Request, Response>({
        method: "POST",
        url: `/file/unassigned/create`,
        requestSchema: RequestSchema,
        responseSchema: ResponseSchema,
        body: variables
      });
    }
  }
);

const RequestCreateFileSchema = z.object({
  document: z.number(),
  task: z.number().nullable(),
  resource: z.number().nullable(),
  client: z.number().nullable(),
  description: z.string().max(255).nullable(),
  board: z.number(),
  is_annotated: z.boolean()
});

const CreateFileResponseSchema = z.object({
  id: z.number(),
  url: z.string(),
  thumbnail_url: z.string().nullable(),
  name: z.string().nullable(),
  task: z.number().nullable(),
  resource: z.number().nullable(),
  client: z.number().nullable(),
  order: z.number(),
  description: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  creator: z.number().nullable(),
  updater: z.number().nullable(),
  size_bytes: z.union([z.string(), z.number()]),
  is_annotated: z.boolean()
});

type RequestCreateFile = z.infer<typeof RequestCreateFileSchema>;
type RequestCreateFileResponse = z.infer<typeof CreateFileResponseSchema>;

export const useCreateFile = createMutation<
  RequestCreateFileResponse,
  RequestCreateFile,
  Error
>({
  mutationFn: async (variables) => {
    return api<RequestCreateFile, RequestCreateFileResponse>({
      method: "POST",
      url: `/file/create`,
      requestSchema: RequestCreateFileSchema,
      responseSchema: CreateFileResponseSchema,
      body: variables
    });
  }
});
